@if (missingAssortments) {
  <div [ngClass]="{'inline': inline}">
    {{'ASSORTMENTS.FIRSTTIMEDELIVERY' | translate}}
  </div>
}